import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import PaperDraggable from "../../../../../components/PaperDraggable";
import {FormProvider, useForm} from "react-hook-form";
import {useMutation, useQueryClient} from "react-query";
import axiosClient from "../../../../../lib/axios";
import {enqueueSnackbar} from "notistack";
import {
    ICriarPrescricao,
    IDetalharPrescricao
} from "../../../../../types/api/receituarioAgronomico/detalhar-prescricoes";
import StepperIncluirPrescricao from './Stepper';

interface DialogIncluirPrescricaoProps {
    open: boolean;
    handleClose: () => void;
    defaultValue?: IDetalharPrescricao | null;
}

export default function DialogIncluirPrescricao({
                                                    open,
                                                    handleClose,
                                                }: Readonly<DialogIncluirPrescricaoProps>) {
    const queryClient = useQueryClient();

    const {mutate: cadastrarPrescricao, isLoading: isSubmitting} = useMutation({
        mutationKey: "cadastrar-prescricao",
        mutationFn: (inputs: ICriarPrescricao) =>
            axiosClient.post("/receituario-agronomico/prescricoes/adicionar-prescricao", inputs),
        onError: (error: any) => {
            console.error("Erro ao cadastrar prescrição:", error);
            enqueueSnackbar(error?.response?.data?.message ?? "Erro ao cadastrar prescrição!", {variant: "error"});
        },
        onSuccess: () => {
            queryClient.invalidateQueries("listar-todas-prescricoes");
            handleClose();
            enqueueSnackbar("Prescrição cadastrada com sucesso!", {
                variant: "success",
            });
        },
    });


    const handleNextStep = () => {
        const stepper = getValues("stepper");
        setValue("stepper", stepper + 1);
    };

    const handleBackStep = () => {
        const stepper = getValues("stepper");
        setValue("stepper", stepper - 1);
    };

    const onSubmit = (data: IDetalharPrescricao) => {
        const payload: ICriarPrescricao = {
            ...data,
            agrotoxico_id: Number(data.agrotoxico?.id),
            cultura_id: Number(data.cultura?.id),
        };
        cadastrarPrescricao(payload);
    };


    const defaultValuesForm = {
        stepper: 0,
        step01: {
            formulacao: "",
            concentracao: "",
            cultura: [],
            agrotoxico: [],
        },
        step02: {
            quantidade_dose: "",
            unidade_dose: "",
            tamanho_area: "",
            unidade_area: "",
            quantidade_aplicacoes: "",
            dias_intervalo_aplicacoes: "",
            dias_carencia: "",
        },
        step03:{
            complemento: "",
            modo_aplicacao: "",
            manejo: "",
            epoca_aplicacao: "",
            grupo_quimico: ""
        },
        funcoesAux: {
            onNext: handleNextStep,
            onBack: handleBackStep,
            onCloseModal: handleClose,
            onSubmit: onSubmit
        },
    };

    const methods = useForm({defaultValues: defaultValuesForm});
    const {getValues, setValue} = methods;

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                fullWidth
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
                maxWidth={"md"}
                scroll="body"
            >
                <DialogTitle sx={{cursor: "move"}} id="draggable-dialog-title">
                    Incluir Prescrição
                </DialogTitle>
                    <DialogContent>
                        <StepperIncluirPrescricao/>
                    </DialogContent>

                    <DialogActions>
                        <Button variant="outlined" onClick={handleClose} disabled={isSubmitting}>
                            Cancelar
                        </Button>
                    </DialogActions>
            </Dialog>
        </FormProvider>
    );
}